
import React, { Component } from "react";

export default class AutoSuggestInput extends Component {
  state = {
    showSuggestions: false,
    filteredSuggestions: [],
  };

  onChangeAction = (e) => {
    const value = e.target.value;
    const { dataList, onChange } = this.props;

    const filteredSuggestions = dataList?.filter((item) =>
      item.name.toLowerCase().includes(value.toLowerCase())
    );

    this.setState({
      showSuggestions: !!filteredSuggestions.length,
      filteredSuggestions: filteredSuggestions || [],
    });

    if (onChange) onChange(e);
  };

  handleSuggestionClick = (value) => {
    const { name, onChange } = this.props;

    this.setState({ showSuggestions: false });

    if (onChange) {
      const fakeEvent = {
        target: {
          name,
          value,
        },
      };
      onChange(fakeEvent);
    }
  };

  handleBlur = () => {
    setTimeout(() => this.setState({ showSuggestions: false }), 150);
  };

  renderSuggestions = () => {
    const { filteredSuggestions, showSuggestions } = this.state;
    if (!showSuggestions) return null;
const suggestionsTitle = this.props.suggestionsTitle || "Suggested options";
    return (
      <ul className="suggestions">
        <span className="suggestions-title">{suggestionsTitle}</span>
        {filteredSuggestions.map((item) => (
          <li
            key={item.id}
            onMouseDown={() => this.handleSuggestionClick(item.name)}
            className="suggestion-item"
          >
            {item.name}
          </li>
        ))}
      </ul>
    );
  };

  render() {
    const { label, name, value, error, required, placeholder, hidelabel } =
      this.props;

    return (
      <div className="input-rapper" style={{ position: "relative" }}>
        <p className="label" style={{ opacity: hidelabel ? "0" : "1" }}>
          {label}
        </p>
        <input
          type="text"
          name={name}
          value={value}
          onChange={this.onChangeAction}
          onBlur={this.handleBlur}
          autoComplete="off"
          placeholder={placeholder}
          className={error ? "input-field error" : "input-field"}
          required={required}
        />
        {this.renderSuggestions()}
        {error && <p className="err">{error}</p>}
      </div>
    );
  }
}
